import React from 'react';
import { Grid, FormControlLabel, Switch, TextField } from '@mui/material';

const IsTangeloInfo = ({ formData, handleChange }) => {
  return (
    <Grid
      container
      spacing={3}
    >
      <Grid
        item
        xs={12}
      >
        <FormControlLabel
          control={
            <Switch
              checked={formData.isTangelo}
              name="isTangelo"
              onChange={handleChange}
            />
          }
          label="Is Tangelo?"
        />
      </Grid>
      {/* {formData.isTangelo && (
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Tangelo Details"
            name="tangeloDetails"
            value={formData.tangeloDetails}
            onChange={handleChange}
          />
        </Grid>
      )} */}
    </Grid>
  );
};

export default IsTangeloInfo;
